import { Resource } from './Resource.js';

export class Metal extends Resource {
  constructor(x, y, amount = 1) {
    super(x, y, amount);
  }

  // Metal can be collected by soldiers below level 5
  // Distance checking is handled by the opportunistic collection logic in SoldierAI
  // This method only checks type eligibility
  canBeCollectedBy(soldier) {
    if (!this.active) return false; // Can't collect inactive resources
    if (this.isBeingCollected) return false; // Already being collected
    return soldier.level < 5;
  }
  
  // Render as a simple gray square
  renderSpecific(ctx, pulse) {
    ctx.fillStyle = '#aaa';
    
    // Apply scaling to size
    const size = 4 * this.scale;
    const halfSize = size / 2;
    
    // Draw centered at 0,0 since context is translated
    ctx.fillRect(-halfSize, -halfSize, size, size);
  }
}